module.exports = __webpack_public_path__ + "img/hr-train-wheels-1.4fbd5e24.png";